module.exports = __webpack_public_path__ + "img/lesPep.89cc8bd3.png";